import { ModeToggle } from '@/components/mode-toggle'
import { navItems } from '@/data/siteContent'
import zatoriLogo from '@/static/zatori.png'

export function SiteHeader() {
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-border/70 bg-background/70 backdrop-blur-xl">
      <div className="mx-auto flex h-[76px] w-full max-w-page items-center justify-between px-5 sm:px-8">
        <a
          href="#hero"
          className="flex items-center gap-3 font-mono text-base font-bold tracking-tight text-primary"
        >
          <img src={zatoriLogo} alt="sekaizato" className="h-10 w-10 object-contain" />
        </a>

        <nav aria-label="Primary navigation" className="hidden items-center gap-8 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-[15px] font-medium text-muted transition duration-300 hover:text-primary"
            >
              <span className={item.label === 'Local' ? 'border-b border-primary pb-1 font-semibold text-primary' : ''}>
                {item.label}
              </span>
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <ModeToggle />
        </div>
      </div>
    </header>
  )
}
